import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from './core/services/auth.service';
import { ROUTER_LINKS } from './shared/constants/app-strings.constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  isLoggedIn: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.cleanupMsalCookies();
    this.isLoggedIn = this.authService.getLoginStatus();
    this.authService.loginLogoutStatus$.subscribe({
      next: () => {
        this.isLoggedIn = this.authService.getLoginStatus();
      },
    });
  }

  /** Remove legacy MSAL cookies to prevent RequestHeaderSectionTooLarge (8KB limit). Tokens are now in sessionStorage. */
  private cleanupMsalCookies(): void {
    try {
      const cookies = document.cookie.split(';');
      const hostname = window.location.hostname;
      cookies.forEach((cookie) => {
        const name = cookie.split('=')[0].trim();
        if (name && name.toLowerCase().includes('msal')) {
          document.cookie = `${name}=; Max-Age=0; path=/`;
          document.cookie = `${name}=; Max-Age=0; path=/; domain=${hostname}`;
          if (hostname.indexOf('.') > 0) {
            document.cookie = `${name}=; Max-Age=0; path=/; domain=.${hostname}`;
          }
        }
      });
    } catch {
      // ignore
    }
  }

  get showSideBar(): boolean {
    const currentRoute = this.router.url;
    if (currentRoute.startsWith(`/${ROUTER_LINKS.library}`)) {
      return true;
    } else {
      return false;
    }
  }
}
